<style scoped lang="scss">
.table-loading-more {
  text-align: center;
  padding-top: 2px;
  color: #666;
  font-size: 14px;

  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      margin-right: 6px;
      font-size: 16px;
    }
  }

  .no-more {
    color: #999;
  }
}
.mark-all-download {
  position: absolute;
  top: 0;
  right: 12px;
}
.shopDropdown-menu{
  width: 240px !important;
  left: 7px !important;
  .el-dropdown-menu__item{
    display: flex;
    align-items: center;
    .memu-supplier-name{
      width: 180px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .lls-icon-check {
      margin-left: 8px;
    }
  }
  
}
.user-operation {
  border-radius: 8px !important;
  width: 180px !important;
}
.user-avatar{
  cursor: pointer;
}
.notification-wrap {
  margin-right: 20px;
}

.root-container {
  background-color: #F7FBFF;
  height: fit-content;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;
  .top-notice {
    min-width: 600px;
    min-height: 35px !important;
    width: 100%;
    background-color: #BDD7EE;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    .text {
      color: #034A5B;
      font-weight: 600;
    }
    .close-btn {
      position: absolute;
      right: 10px;
      cursor: pointer;
    }
  }
  nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    margin: 0px;
    padding: 0px 16px;
    height: 48px;
    margin-bottom: 3px;
    flex-shrink: 0;
  }

  .loginLogo {
    float: left;
  }

  .head-msg {
    float: right;
    padding-top: 12px;
    display: flex;
    color: #333;
    padding-left: 15px;
  }

  .login-msg-item {
    border-right: 1px solid #d7d7d7;
    height: 20px;
    padding: 0 15px;
    align-items: center;
    display: flex;
  }

  .head-user {
    border-right: 0px solid #d7d7d7;
    position: relative;
    padding-right: 0px;
  }

  .head-user-icon {
    background: url(../static/img/menu/i-todown.png) no-repeat right center;
    width: 10px;
    height: 10px;
  }

  .head-box {
    width: 120px;
    border: 1px solid #e6e6e6;
    border-radius: 5px;
    position: absolute;
    top: 33px;
    right: 0px;
    z-index: 10;
    background-color: #fff;
  }

  .head-item {
    height: 36px;
    width: 120px;
    cursor: pointer;
    color: #333;
    line-height: 36px;
    font-size: 14px;
    padding-left: 38px;
  }

  .head-logout {
    border-bottom: 1px solid #e6e6e6;
    background: url(../static/img/auto/logout_d.png) no-repeat 15px center;
    border-radius: 5px 5px 0 0;
  }

  .head-logout:hover {
    background: #00a0e4 url(../static/img/auto/logout_a.png) no-repeat 15px
      center;
    color: #fff;
  }

  .head-reset {
    background: url(../static/img/auto/reset_d.png) no-repeat 15px center;
    border-radius: 0 0 5px 5px;
  }

  .head-reset:hover {
    background: #00a0e4 url(../static/img/auto/reset_a.png) no-repeat 15px
      center;
    color: #fff;
  }

  .main {
    display: flex;
    top: 50px;
  }

  /*主内容界面样式*/
  .content-container-root {
    flex: 1;
    box-sizing: border-box;
    padding: 0 0 0px;
    overflow-x: auto;
    overflow-y: auto;
    white-space: nowrap;
    /*background-color:#ECEEF0;*/
    width: calc(100vw - 170px);
    height: 100%;
    padding: 0px 20px 30px 15px;
    /* padding-bottom: 30px; */
  }

  .content-wrapper {
    height: 100%;
    width: 100%;
    // box-shadow: 0px 2px 0px  rgba(87, 138, 209, 0.08);
  }

  .bgwatermark {
    position: absolute;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    overflow: hidden;
  }

  .bglogo {
    background: url(../static/img/bglogo.png) no-repeat;
    width: 130px;
    height: 130px;
    float: left;
    margin-left: 200px;
    margin-top: 100px;
    background-size: 70%;
  }

  .bgname {
    font-size: 25px;
    opacity: 0.1;
    transform: rotate(-32deg);
    width: 80px;
    margin-top: 76px;
    margin-left: 11px;
  }

  .nav-logo {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .logo {
      width: auto;
      height: 32px;
      width: 100px;
      height: 25px;
    }

    .enlarge {
      width: 105px;
      height: auto;
    }
  }

  .nav-logo-text {
    margin-left: 24px;
    color: #193966d7;
    font-size: 18px;
    font-weight: bold;
  }

  @media screen and (max-width: 600px) {
    .nav-logo-text {
      display: none;
    }
  }
  
  .el-dropdown-link {
    &:hover {
      background-color: #5A9CF814;
    }
    cursor: pointer;
    margin-right: 24px;
    vertical-align: middle;
    display: flex;
    padding: 10px 10px;
    .icon {
      width: 22px;
      height: 22px;
    }
    .sup-name{
      margin-left: 10px; 
      width: 130px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .up-down{
      height: 100%;
      margin-left: 5px;
      margin-top: 3px;
    }
  }

  .el-dropdown-link:hover .el-icon-arrow-down {
    transform: rotate(180deg);
  }

  .el-icon-arrow-down {
    font-size: 12px;
    color: #4a4a4a;
    font-weight: bold;
    transition: all 0.3s ease;
  }

  .nav-right {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #4A4A4A;
    .buy-car {
      position: relative;
      margin-right: 16px;
      cursor: pointer;

      img {
        width: 20px;
        height: 20px;
        color: #4a4a4a;
      }

      .dot {
        position: absolute;
        top: -37%;
        right: -50%;
        opacity: 1;
        font-weight: 400;

        background-color: #FF4040;
        border-radius: 10px;
        color: #FFF;
        display: inline-block;
        font-size: 12px;
        height: 18px;
        line-height: 18px;
        padding: 0 6px;
        text-align: center;
        white-space: nowrap;
        border: 1px solid #FFF;
      }
    }

    .account-setting {
      margin-right: 24px;
    }
  }

  .nav-right-text {
    color: #fff;
    font-size: 12px;
    margin-right: 10px;
  }

  .nav-right-time {
    border-radius: 16px;
    box-sizing: border-box;
    font-size: 14px;
    line-height: 32px;
    // width: 184px;
    height: 32px;
    padding-left: 32px;
    background: rgba(90, 156, 248, 0.2) url('../static/projImg/time-left.svg')
      10px center no-repeat;
    color: #fff;
    font-weight: bold;
    margin-right: 30px;
    padding-right: 8px;
  }

  ::v-deep .menu-box {
    height: calc(100vh - 50px);
    width: 220px;
    margin-right: 5px;
    margin-right: 5px;
    // box-shadow: 0 0 10px 0 rgba(87, 138, 209, 0.15);
    box-shadow: 0px 0px 10px rgba(87, 138, 209, 0.08);
    border-radius: 8px;
    padding: 20px 12px;
    box-sizing: border-box;
    background-color: #FFF;
    .el-submenu {
      .el-menu-item {
        padding-left: 40px !important;
      }

      .el-submenu__title {
        padding: 0 12px !important;
        background-color: #F7FBFF;
      }
    }

    .el-submenu__icon-arrow,
    .el-icon-arrow-right {
      right: 12px !important;
      top: 53%;
    }

    .el-menu-item {
      padding: 14px 12px !important;
      background-color: #F7FBFF;
    }

    .el-menu-item.is-active {
      background-color: #d9e9ff;
      font-weight: normal;
    }

    // margin-top: 34px;
    .el-menu-item .el-popover__reference {
      display: block;
    }
  }

  .menu-box {
    ::v-deep {
      .el-submenu__title {
        display: flex;
        align-items: center;
      }

      .el-submenu__title i {
        flex-shrink: 0;
      }
    }
  }

  .menu-title1 {
    position: relative;
    // flex-grow: 1;
    margin-left: 8px;
    width: 125px;
    word-wrap: break-word;
  }

  .menu-title1 .menu-title-more {
    float: right;
    margin-top: 18px;
    font-size: 14px;
  }

  .menu-title-more.menu-selected {
    font-weight: bold;
  }

  .menu-sub-box {
    position: absolute;
    right: -137px;
    top: 0px;
    width: 120px;
    box-sizing: border-box;
    /*height: 189px;*/
    /*padding: 10px 0px;*/
    border-radius: 8px;
    border: 1px solid #adcefc;
    background: #ffffff;
    z-index: 9;

    /*display: none;*/
  }

  .menu-sub-box-en {
    position: absolute;
    right: -168px;
    top: 0px;
    width: 150px;
    box-sizing: border-box;
    /*height: 189px;*/
    /*padding: 10px 0px;*/
    border-radius: 8px;
    border: 1px solid #adcefc;
    background: #ffffff;
    z-index: 9;

    /*display: none;*/
  }

  .menu-sub-box-item {
    padding: 0 10px;
    font-weight: normal;
    font-size: 14px;
    color: #4a4a4a;
    height: 32px;
    line-height: 32px;
    cursor: pointer;
  }

  .menu-sub-box-item:hover {
    background-color: rgba(90, 156, 248, 0.15);
  }

  .menu-sub-box-item.menu-sub-box-item-actived {
    background-color: rgba(90, 156, 248, 0.15);
  }

  .menu-title1-box:hover .menu-title1 .menu-sub-box {
    display: unset;
  }

  .short-menu-box {
    width: 50px;
    height: 50px;
    // box-shadow: 0 0 10px 0 rgba(87, 138, 209, 0.05);
    // border-top-right-radius: 20px;
    // border-bottom-right-radius: 20px;
    // position: absolute;
    // left: 0px;
    // top: 4px;
    background: transparent url('~@/static/projImg/short-menu-icon.svg') center
      center no-repeat;
    cursor: pointer;

    .wrap-short-menu-box {
      width: 100%;
      height: 100%;
      position: relative;
    }
    .short-menu-sub-box {
      position: fixed;
      margin-top: 0px;
      overflow: visible;
      z-index: 10;
    }
  }

  .icon-exam {
    display: inline-block;
    width: 16px;
    height: 16px;
    background: url('~@/static/img/exam-mode.svg') center center no-repeat;
    margin-bottom: -3px;
  }
}

.icon-shopping-bag::before {
  content: '';
  display: inline-block;
  width: 16px;
  height: 16px;
  background: url('~@/static/img/shopping-bag.svg') center center no-repeat;
  margin-bottom: -4px;
}

.icon-template::before {
  content: '';
  display: inline-block;
  width: 16px;
  height: 16px;
  background: url('~@/static/img/template.svg') center center no-repeat;
  margin-bottom: -4px;
}
// 小屏下菜单字体样式
.menu-title {
  color: #4e78b1;
  height: 50px;
  display: flex;
  align-items: center;
}
.menu-box-show {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media screen and (max-width: 1140px) {
  .menu-box-show {
    display: none;
  }

  .title-PDL15 {
    padding-left: 15px;
  }
}

@media screen and (min-width: 1140px) {
  .short-menu-box {
    display: none;
  }
}

::v-deep .resetPwd-box {
  .el-dialog {
    min-width: 320px;
    max-width: 605px;

    .el-dialog__footer {
      .dialog-footer {
        display: flex;
        justify-content: center;
        width: 100%;
        padding: 10px 0px 5px 0px;
      }
    }
  }
}
::v-deep {
  .lls-collapse {
    border-radius: 8px;
    background: #fff;
    padding: 16px 8px;
    .lls-collapse-item {
      margin-top: 0;
      background: #fff;
      border-radius: 0 !important;
    }
    .lls-collapse-item__wrap {
      overflow: visible;
    }
    .lls-collapse-item__header {
      padding: 0 8px;
      height: 50px;
    }
    .lls-collapse-item__arrow {
      color: #4e78b1;
      right: 8px;
    }
    .lls-collapse-item__content {
      border: none;
      padding: 0;
      margin: 0;
    }
  }
  .lls-menu--vertical {
    padding: 0;
    box-shadow: none;
    border-radius: 0;
  }
  .lls-menu--vertical {
    box-shadow: none;
    -webkit-box-shadow: none;
  }
  .lls-submenu__arrow {
    color: #4e78b1;
  }
  .lls-menu-item {
    padding-left: 30px;
    height: 50px !important;
    border-radius: 8px;
    overflow: hidden;
    &:hover {
      color: #2e5a99;
      background-color: #ebf3ff;
    }
  }
  .lls-menu-item.is-active {
    color: #2e5a99 !important;
    background-color: #ebf3ff !important;
    border-radius: 8px;
  }
  .lls-submenu.is-active {
    color: #2e5a99 !important;
    background-color: #ebf3ff !important;
    border-radius: 8px;
  }
  .lls-submenu__title {
    padding-left: 30px;
    height: 50px !important;
    border-radius: 8px;
    &:hover {
      color: #2e5a99;
      background-color: #ebf3ff;
    }
  }
  .lls-submenu__content {
    width: 200px;
    transform: translateX(calc(100% + 8px));
  }
  .lls-submenu__content .lls-submenu__content {
    transform: translateX(100%);
  }
}

.menu-mask {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 5;
}

.shopDropdownList {
  .el-dropdown-menu__item:first-of-type {
    padding: 0px;

    ::v-deep .el-input__inner {
      padding-left: 20px;
      border: 0;
    }
  }
}

.download-mgm {
  margin-right: 20px;
}

.download-status {
  display: flex;
  align-items: center;

  img {
    width: 16px;
    height: 16px;
    margin-left: 8px;
  }

  span {
    margin-left: 8px;
  }

  &.download-status_success {
    color: #0acc8b;
  }

  &.download-status_failed {
    color: #ff4040;
  }

  &.download-status_pending {
    color: #ff9326;
  }
}
</style>
<style lang="scss">

.change-lang-menu,
.change-role-menu{
  .lang-change-icon,
  .role-change-icon{
    position: relative;
    top: -2px;
    margin-right: 7px;
  }
  .lls-submenu__title{
    height: 38px !important;
    line-height: 38px !important;
    color: unset !important;
    background-color: unset  !important;
    &:hover {
      background-color: #ebf3ff !important;
    }
  }
  .lls-submenu__content{
    width: 160px;
    transform: translateX(calc(100% - 340px));
    .lls-menu-item{
      height: 50% !important;
      line-height: 35px !important;
      .title-contain{
        display: flex;
        justify-content: space-between;
        i {
          line-height: 35px;
        }
      }
    }
  }
}

.topbar-user-info{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  img {
    height: 18px;
    width: 18px;
    margin-right: 5px;
  }
  .user-name{
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.menu-popper {
  min-width: 100px !important;
  left: 186px !important; // popover弹窗位置，写死不太好又要向右偏移，暂时这样子
  padding: 0px !important;
  border: 1px solid #3e8cfa !important;
  border-radius: 8px !important;
  box-shadow: 2px 2px 10px 0px rgba(46, 90, 153, 0.2) !important;
  .subPopover {
    height: 30px;
    line-height: 30px;
    padding: 0px 20px;
    cursor: pointer;
  }

  .subPopover-active {
    color: #5a9cf8;
    background-color: rgba(90, 156, 248, 0.15);
  }

  .subPopover:hover {
    color: #2e5a99;
    background-color: #ebf3ff;
    /* border-radius: 8px; */
  }

  .subPopover:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .subPopover:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
}

//菜单换行
.menu-item-wrap {
  display: inline-block;
  white-space: pre-wrap;
  line-height: 16px;
}
.product-center {
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
  margin-left: 30px;
  cursor: pointer;
}
</style>

<template>
  <div class="root-container">
    <!-- dev-8.0.25 系统更名unloqX---顶部公告模块 -->
    <div v-if="showTopNotice" class="top-notice">
      <div class="text" v-html="$t('bigHome.topNotice')"></div>
      <i @click="handleCloseNotice" class="lls-icon-close close-btn"></i>
    </div>
    <!--头部登录信息-->
    <nav>
      <div class="nav-logo title-PDL15">
        <div class="short-menu-box">
          <div
            v-show="shortMenuShow"
            class="menu-mask"
            @click="shortMenuShow = false"
          ></div>
          <div
            class="wrap-short-menu-box"
            @click="shortMenuShow = !shortMenuShow"
          ></div>
          <div
            v-if="shortMenuShow"
            class="menu-box short-menu-sub-box"
            style="z-index: 10;"
          >
            <el-menu
              :default-active="menuIndex"
              class="el-menu-vertical-demo"
              :collapse="isCollapse"
              @select="selectMenu"
              v-clickoutside="clickoutsideFun"
              ref="menuRef"
              :unique-opened="true"
              >
              <div v-for="item in showingProduct.children" :key="item.id">
                <template v-if="item.children && item.children.length > 0">
                  <el-submenu :index="item.id">
                    <template slot="title">
                      <svg-icon :iconClass="item.icon" fill="#2E5A99"></svg-icon>
                      <span class="menu-title1 menu-item-wrap">{{
                        $i18n.locale == 'en' ? item.nameEn : item.name
                      }}</span>
                    </template>
                    <div
                      v-for="m2 in item.children"
                      :key="m2.id"
                      @click="showSubPopper(m2.id)"
                    >
                      <el-menu-item
                        v-if="m2.children && m2.children.length > 0"
                        :index="m2.id"
                      >
                        <el-popover
                          placement="right"
                          :visible-arrow="false"
                          popper-class="menu-popper"
                          trigger="click"
                          :ref="`popoverRef${m2.id}`"
                        >
                          <div
                            v-for="m3 in m2.children"
                            :key="m3.id"
                            :class="[
                              'subPopover',
                              m3subActive === m3.id ? 'subPopover-active' : '',
                            ]"
                            @click="subMenuClick(m3, m2)"
                          >
                            <span class="menu-item-wrap">{{
                              $i18n.locale == 'en' ? m3.nameEn : m3.name
                            }}</span>
                          </div>
                          <span slot="reference">
                            <span class="menu-item-wrap">{{
                              $i18n.locale == 'en' ? m2.nameEn : m2.name
                            }}</span>
                            <i
                              class="el-icon-arrow-right"
                              style="
                                zoom: 0.75;
                                position: absolute;
                                right: 17px;
                                top: 25px;
                              "
                            ></i>
                          </span>
                        </el-popover>
                      </el-menu-item>
                      <el-menu-item
                        v-else
                        :index="m2.id"
                        @click="subMenuClick(m2, showingProduct)"
                      >
                        <i :class="m2.icon"></i>
                        <span slot="title" class="menu-item-wrap">{{
                          $i18n.locale == 'en' ? m2.nameEn : m2.name
                        }}</span>
                      </el-menu-item>
                    </div>
                  </el-submenu>
                </template>
                <el-menu-item v-else :index="item.id" @click="menuclick(item)">
                  <svg-icon :iconClass="item.icon" fill="#2E5A99"></svg-icon>
                  <span slot="title" class="menu-title1 menu-item-wrap">{{
                    $i18n.locale == 'en' ? item.nameEn : item.name
                  }}</span>
                </el-menu-item>
              </div>
            </el-menu>
          </div>
        </div>
        <img :src="LogoSrc" alt="logo" class="logo" />
        <switchProduct
          :navs="productList"
          ref="switchProductRef"
          @switchProduct="switchProduct"
          @gotoAcc="gotoAcc"
          @gotoDTT="gotoDTT"
        ></switchProduct>
      </div>
      <div class="nav-right">
        <!-- 消息通知 -->
        <Notification class="notification-wrap" @notification-count="handleNotificationCount"></Notification>

        <template v-if="iddTimeShow">
          <!-- 闭市截止时间 -->
          <div class="nav-right-text">
            {{ $t('common.countdownMarketClosure') }}
          </div>
          <div class="nav-right-time">
            {{ timeObj.hour }}{{ $t('common.hour') }}:{{ timeObj.minute
            }}{{ $t('common.minute') }}:{{ timeObj.second
            }}{{ $t('common.second') }}
          </div>
        </template>
        <!-- ========================================= 购物车 ========================================= -->
        <div class="buy-car" @click="goBuyCar" v-if="addCartShow">
          <img src="@/static/projImg/buyCar.svg"  />
          <span class="dot" v-if="cartNum > 0">{{ cartNum }}</span>
        </div>
        <!-- ========================================= 资金方台账下载 ========================================= -->
        <DigipoDownloadMgm v-if="productType == 'DIGIPO'"></DigipoDownloadMgm>
        <el-popover
          v-else
          placement="bottom"
          @show="handlePopShow"
          :title="$t('bigHome.downloadManagement')"
          width="600"
          trigger="click"
        >
          <el-button 
            v-if="ledgerToBeDownloadedCount"
            type="text" 
            class="mark-all-download"
            @click="markDownloadedFunc({markAllDownloaded: true})"
          >
            {{ $t('message.markAllAsDownloaded') }}
          </el-button>
          <el-table :data="gridData" ref="tableRef" height="340px" :loading="isLoadingMore">
            <el-table-column type="index" width="50" :label="$t('bigHome.No')">
            </el-table-column>
            <el-table-column
              width="180"
              :show-overflow-tooltip="true"
              property="fileName"
              :label="$t('bigHome.fileName')"
            ></el-table-column>
            <el-table-column width="150" :label="$t('bigHome.status')">
              <template slot-scope="{ row }">
                <div
                  class="download-status"
                  :class="STATUS_MAP[row.statusKey].class"
                >
                  <img :src="STATUS_MAP[row.statusKey].path" />
                  <span>{{ row.statusDisplay }}</span>
                  <el-tooltip
                    v-if="
                      row.statusDisplay == 'Failed' ||
                        row.statusDisplay == '失败'
                    "
                    class="item"
                    effect="dark"
                    :content="row.errorMsgShow"
                    placement="top"
                  >
                    <img src="@/assets/help@2x.png" alt="" />
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              width="200"
              property="createTime"
              :label="$t('bigHome.createTime')"
            ></el-table-column>
            <el-table-column
              width="106"
              :label="$t('bigHome.action')"
              fixed="right"
            >
              <template slot-scope="{ row }">
                <el-button
                  :type="
                    row.isDownload && filterDictParam(row.isDownload) == 'YES' ? 'common' : 'primary'
                  "
                  plain
                  :disabled="
                    row.statusDisplay != 'Success' && row.statusDisplay != '成功'
                  "
                  @click="handleDownload(row)"
                  size="small"
                  >{{ $t('bigHome.download') }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 底部加载状态和无更多数据提示 -->
          <div class="table-loading-more" v-if="gridData.length > 0">
            <div v-if="isLoadingMore && hasMore" class="loading">
              <i class="el-icon-loading"></i>
              <span>{{ $t('message.loading') }}</span>
            </div>
            <!-- <div v-if="!hasMore" class="no-more">
              {{ $t('message.noMoreData') }}
            </div> -->
          </div>

          <div class="download-mgm" slot="reference">
            <el-button  type="text"
              ><img src="@/assets/topBar/download.svg" alt=""
            /></el-button>
            <lls-badge v-if="ledgerToBeDownloadedCount" :value="ledgerToBeDownloadedCount" :max="99" style="margin-top: -13px; margin-left: -10px;"></lls-badge>
          </div>
        </el-popover>
        <!-- 用户中心按钮 -->
        <!-- <div style="margin-right:20px;cursor:pointer" @click="toProductCenter">
          <img src="@/assets/topBar/userCenterIcon.svg" alt="">
        </div> -->
        <!-- 右上角用户操作 -->
        <lls-dropdown trigger="click">
          <img class="user-avatar" src="@/assets/topBar/avater.png" alt="">
          <lls-dropdown-menu slot="dropdown" class="user-operation">
            <!-- 用户信息 -->
            <lls-dropdown-item>
              <div class="topbar-user-info">
                <img src="@/assets/topBar/avater.png" alt="">
                <span :title="userName" class="user-name">{{ userName | filterUndefinedNull }}</span>
              </div>
            </lls-dropdown-item>
            <!-- v8.0.7语言切换 -->
            <lls-menu trigger="hover">
              <lls-submenu index="2" class="change-lang-menu">
                <template slot="title">
                  <img class="lang-change-icon" src="@/static/img/langChange.svg" alt="">
                  <span>{{ $t('login.lang') }}</span>
                </template>
                <lls-menu-item index="2-2" @click.native.stop="changeLangBigHome('en')">
                  <div class="title-contain">
                    <span>English</span>
                    <i v-show="this.$i18n.locale == 'en'" class="lls-icon-check"></i>
                  </div>
                </lls-menu-item>
                <lls-menu-item index="2-1" @click.native.stop="changeLangBigHome('zh')">
                  <div class="title-contain">
                    <span>简体中文</span>
                    <i v-show="this.$i18n.locale == 'zh'" class="lls-icon-check"></i>
                  </div>
                </lls-menu-item>
              </lls-submenu>
              <!-- 贸易角色切换：与语言切换放在同一 lls-menu 内，保证二级框互斥；角色数量小于等于一个时隐藏入口，默认选中该角色 -->
              <lls-submenu v-if="tradeRoleList.length > 1" index="3" class="change-role-menu">
                <template slot="title">
                  <img class="role-change-icon" src="@/static/img/tradeRole.svg" alt="">
                  <span>{{ $t('login.tradeRole') }}</span>
                </template>
                <lls-menu-item
                  v-for="(item, idx) in tradeRoleList"
                  :key="item.dictParam"
                  :index="`3-${idx + 1}`"
                  @click.native.stop="changeTradeRole(item.dictParam)"
                >
                  <div class="title-contain">
                    <span>{{ item.displayName }}</span>
                    <i v-show="tradeRole === item.dictParam" class="lls-icon-check"></i>
                  </div>
                </lls-menu-item>
              </lls-submenu>
            </lls-menu>
            <!-- 重置密码 -->
            <lls-dropdown-item @click.native="resetPwd">
              {{ $t('login.changePassword') }}
            </lls-dropdown-item>
            <!-- 退出登录 -->
            <lls-dropdown-item @click.native="logout">
              {{ $t('login.logout') }}
            </lls-dropdown-item>
          </lls-dropdown-menu>
        </lls-dropdown>
      </div>
    </nav>
    <div class="main" id="main">
      <!-- 菜单组件 -->
      <div
        class="menu-box menu-box-show"
        v-if="
          menuHide && ((
          showingProduct.children && 
          showingProduct.children.length) || showingProduct.menuProductType === 'DEFAULT')
        "
      >
        <el-menu
          :default-active="menuIndex"
          class="el-menu-vertical-demo"
          :collapse="isCollapse"
          @select="selectMenu"
          v-clickoutside="clickoutsideFun"
          ref="menuRef"
          :unique-opened="true"
          >
          <div v-for="item in showingProduct.children" :key="item.id">
            <template v-if="item.children && item.children.length > 0">
              <el-submenu :index="item.id">
                <template slot="title">
                  <svg-icon :iconClass="item.icon" fill="#2E5A99"></svg-icon>
                  <span class="menu-title1 menu-item-wrap">{{
                    $i18n.locale == 'en' ? item.nameEn : item.name
                  }}</span>
                </template>
                <div
                  v-for="m2 in item.children"
                  :key="m2.id"
                  @click="showSubPopper(m2.id)"
                >
                  <el-menu-item
                    v-if="m2.children && m2.children.length > 0"
                    :index="m2.id"
                  >
                    <el-popover
                      placement="right"
                      :visible-arrow="false"
                      popper-class="menu-popper"
                      trigger="click"
                      :ref="`popoverRef${m2.id}`"
                    >
                      <div
                        v-for="m3 in m2.children"
                        :key="m3.id"
                        :class="[
                          'subPopover',
                          m3subActive === m3.id ? 'subPopover-active' : '',
                        ]"
                        @click="subMenuClick(m3, m2)"
                      >
                        <span class="menu-item-wrap">{{
                          $i18n.locale == 'en' ? m3.nameEn : m3.name
                        }}</span>
                      </div>
                      <span slot="reference">
                        <span class="menu-item-wrap">{{
                          $i18n.locale == 'en' ? m2.nameEn : m2.name
                        }}</span>
                        <i
                          class="el-icon-arrow-right"
                          style="
                            zoom: 0.75;
                            position: absolute;
                            right: 17px;
                            top: 25px;
                          "
                        ></i>
                      </span>
                    </el-popover>
                  </el-menu-item>
                  <el-menu-item
                    v-else
                    :index="m2.id"
                    @click="subMenuClick(m2, showingProduct)"
                  >
                    <i :class="m2.icon"></i>
                    <span slot="title" class="menu-item-wrap">{{
                      $i18n.locale == 'en' ? m2.nameEn : m2.name
                    }}</span>
                  </el-menu-item>
                </div>
              </el-submenu>
            </template>
            <el-menu-item v-else :index="item.id" @click="menuclick(item)">
              <svg-icon :iconClass="item.icon" fill="#2E5A99"></svg-icon>
              <span slot="title" class="menu-title1 menu-item-wrap">{{
                $i18n.locale == 'en' ? item.nameEn : item.name
              }}</span>
            </el-menu-item>
          </div>
        </el-menu>
        <!-- 店铺名称下拉 -->
        <div class="shop-drop-contain">
          <el-dropdown
            trigger="click"
            :hide-on-click="false"
            class="shopDropdown"
            ref="shopDropdownRef"
          >
            <div class="el-dropdown-link">
              <img class="icon" src="@/assets/topBar/supplierLogo.svg"/>
              <div class="sup-name" :title="shopName">{{ shopName }}</div>
              <img class="up-down" src="@/assets/topBar/upDown.png"  />
            </div>
            <el-dropdown-menu class="shopDropdown-menu" slot="dropdown">
              <el-dropdown-item>
                <el-input
                  v-model="compName"
                  @input="filterShopName"
                  size="mini"
                  placeholder="Search"
                  suffix-icon="el-icon-search"
                ></el-input>
              </el-dropdown-item>
              <el-dropdown-item
                v-for="item in shopNameList"
                :key="item.enterpriseId"
                @click.native="changeShop(item)"
              >
                <i class="icon-shopping-bag"></i>
                <div :title="$i18n.locale == 'zh'? item.companyNameCn || item.companyName: item.companyName || item.companyNameCn" class="memu-supplier-name">
                  {{
                    $i18n.locale == 'zh'
                      ? item.companyNameCn || item.companyName
                      : item.companyName || item.companyNameCn
                  }}
                </div>
                <i v-show="shopName === ($i18n.locale == 'zh' ? (item.companyNameCn || item.companyName) : (item.companyName|| item.companyNameCn))" class="lls-icon-check"></i>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <!--右侧主页面-->
      <section class="content-container-root">
        <!--内容页-->
        <div class="content-wrapper" v-if="finishHome">
          <!--显示默认效果-->
          <router-view :key="contentWrapperKey"></router-view>
        </div>
      </section>
    </div>
    <el-dialog
      class="resetPwd-box"
      :title="$t('login.changePassword')"
      :visible.sync="isResetPwd"
      @close="toClose"
      :close-on-click-modal="false"
      width="85%"
    >
      <div class="err-text"></div>
      <el-form
        :model="formReset"
        :rules="formResetrules"
        ref="formReset"
        status-icon
        hide-required-asterisk
        :validate-on-rule-change="false"
      >
        <el-form-item
          prop="oldPassword"
          ref="oldPassword"
          :label="$t('login.oldPassword')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="formReset.oldPassword"
            show-password
            autocomplete="off"
            @focus="clearMsgErr('oldPassword')"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="password"
          ref="password"
          :label="$t('login.newPassword')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="formReset.password"
            show-password
            autocomplete="off"
            @focus="clearMsgErr('password')"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          prop="confirmPassword"
          ref="confirmPassword"
          :label="$t('login.confirmNewPassword')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="formReset.confirmPassword"
            show-password
            autocomplete="off"
            @focus="clearMsgErr('confirmPassword')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="err-text" style="padding-left: 120px">{{ resetErrMsg }}</div>
      <div slot="footer" class="dialog-footer">
        <!-- 取 消 -->
        <el-button @click="toClose">{{ $t('login.cancel') }}</el-button>
        <!-- 确 定 -->
        <el-button type="primary" @click="toReset('formReset')">
          {{ $t('login.confirm') }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 
    // attention
    companyChooseAlert 选择企业页面，route路由 -> path: '/companyChoose'
    在登录的时候已经访问了一次，home页面再次引入会跑多一次里面的逻辑，需要注意
    在这里之所以直接引入的原因：切换店铺之后又要跑companyChoose的逻辑（例如调setOrgId，平台协议等等）
    后续如果因为这个地方又调多一次逻辑导致需求互斥（或者逻辑混乱）就要把companyChoose选择店铺的逻辑给抽离出来
    -->
    <!-- <div v-if="showCompChoose"> -->
    <!-- @sure="compSure" -->
    <companyChooseAlert
      :showCompChoose.sync="showCompChoose"
      :tableList="userCompanyList"
      @close="compClose"
      @getProductInfo="getProductInfo"
      @getProductCenterList="getProductCenterList"
      ref="companyDialogRef"
    ></companyChooseAlert>
    <!-- </div> -->

    <CfcaAgreementSignDialog
      :visible.sync="cfcaAgreementDialogVisible"
      :cfcaAggrementId="cfcaAggrementId"
      :cfca-template-path="cfcaTemplatePath"
      @confirm="handleCfcaAgreementConfirm"
      @cancel="handleCfcaAgreementCancel"
    />
  </div>
</template>

<script>
// import Menu from '@/components/menu/menu.vue'
import DigipoDownloadMgm from './digipoDownloadMgm.vue'
import { mapState, mapGetters, mapActions } from 'vuex'
import companyChooseAlert from '@/views/companyChooseAlert/companyChooseAlert.vue'
import switchProduct from '@/views/components/switchProduct'
import Notification from '@/views/notification/Index'
import { filterDictParam, gotoAcc } from '@/common/util.js'
import LogoSrc from "@/static/projectImg/login/logo.png"
import CfcaAgreementSignDialog from '@/components/CfcaAgreementSignDialog'
import {
  fetchTradeRoleList,
  filterMenusByTradeRole,
  getCachedTradeRoleList,
  ROLE_FILTER_EXEMPT_MENU_CODES,
  setOrgRole,
  syncTradeRoleAfterSetOrg,
} from '@/utils/tradeRole'
const navsValueList = [
  {
    mapCode:'MORE10000',
    nameEn:'Product Center',
    name:'产品中心',
    activeTitle:'My Unloq',
    point:10,
    url: "/main-productCenter",
    menuUrl: "/main-productCenter",
  },
  {
    mapCode:'MEUC8002',
    nameEn:'Finance',
    name:'供应链融资',
    activeTitle:'Unloq Finance',
    point:9
  },
  {
    mapCode:'MEUC7001',
    nameEn:'Pay',
    name:'跨境支付',
    activeTitle:'Unloq Pay',
    point:8
  },
  {
    mapCode:'MEUC9001',
    nameEn:'Marketplace',
    name:'资产交易平台',
    activeTitle:'Unloq Marketplace',
    point:7
  },
  {
    mapCode:'MEUC91004',
    nameEn:'Digipo',
    name:'多级流转',
    activeTitle:'Digipo',
    point:6
  },
  {
    mapCode:'MEUC8006',
    nameEn:'International Settlement',
    name:'国际结算',
    activeTitle:'International Settlement',
    point:5.5
  },
  {
    mapCode:'MEUCN9000',
    nameEn:'Export Drawback',
    name:'出口退税',
    activeTitle:"Export Drawback",
    point:5
  },
  {
    mapCode:'MEUCN9100',
    nameEn:'Export Drawback',
    name:'出口退税',
    activeTitle:"Export Drawback",
    point:5
  },
  {
    mapCode:'MEUC8004',
    nameEn:'iDD',
    name:'iDD',
    activeTitle:"iDD",
    point:4
  },
  {
    mapCode:'MEUC8005',
    nameEn:'Digital Trade',
    name:'单据流转',
    activeTitle:"Digital Trade",
    point:3
  },
  {
    mapCode:'MORE10000',
    nameEn:'+ More Product',
    name:'+ 探索更多',
    activeTitle:'+ More Product',
    point:2,
    url: "/main-productCenter",
    menuUrl: "/main-productCenter"
  },
]
export default {
  name: 'home',
  components: {
    // Menu
    companyChooseAlert,
    switchProduct,
    DigipoDownloadMgm,
    Notification,
    CfcaAgreementSignDialog
  },
  provide() {
    return {
      switchProductByMenuCode: this.switchProductByMenuCode,
    }
  },
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('login.pleaseEnterNewPassword')))
      } else if (value !== this.formReset.password) {
        callback(new Error(this.$t('login.passwordIncorrectAgain')))
      } else {
        callback()
      }
    }
    return {
      cfcaAggrementId: '',
      cfcaTemplatePath: '',
      /** 变更后强制重载 content-wrapper 内 router-view */
      contentWrapperKey: 0,
      // 下载任务滚动加载
      pageNum: 1,        // 当前页码（初始为1）
      pageSize: 10,      // 每页条数
      isLoadingMore: false, // 加载更多的状态锁（防止重复请求）
      hasMore: true,      // 是否还有更多数据
      cfcaAgreementDialogVisible: false,
      // -------------
      productList:[],
      activeLang:this.$i18n.locale == 'zh' ? '2-1' : '2-2',
      tradeRole: localStorage.getItem('tradeRole') || 'SUPPLIER',
      tradeRoleList: getCachedTradeRoleList(),
      LogoSrc,
      pCenterList: [],
      downloadTableLoading: false,
      STATUS_MAP: {
        PENDING: {
          path: require('@/assets/warning--filled.svg'),
          class: 'download-status_pending',
        },
        FAILED: {
          path: require('@/assets/warning--filled2.svg'),
          class: 'download-status_failed',
        },
        SUCCESS: {
          path: require('@/assets/checkmark--filled.svg'),
          class: 'download-status_success',
        },
      },
      addCartShow: false,
      cartNum: 0,
      menuHide: true,
      menuIndex: '1',
      shortMenuIndex: '',
      m3subActive: '',
      isCollapse: false,
      isMore: false, //是否展示退出登录和重置密码等功能
      userName: '',
      bglogoArr: [],
      //以下是密码重置相关的
      isResetPwd: false, //是否显示重置密码弹框
      // pwd: "",//新密码
      // pwdConfirm: "",//确认密码
      resetErrMsg: '', //重置密码的错误提示信息
      isReseting: false, //是否重置密码中
      navs: [],
      shortNavs: [], // 缩小后菜单列表
      navsUser: [], //账户管理
      navsBtnShow: true, //是否展示账户中心按钮
      navsSwitch: [], //除去账户管理
      finishHome: false,
      showCompChoose: false,
      userCompanyList: [],
      compName: '',
      timer: null,
      timeObj: {
        hour: '00',
        minute: '00',
        second: '00',
      },
      //重置密码
      formReset: {
        confirmPassword: '',
        oldPassword: '',
        password: '',
      },
      formLabelWidth: '165px',
      formResetrules: {
        oldPassword: [
          {
            required: true,
            message: this.$t('login.pleaseEnterOldPassword'),
            trigger: 'submit',
          },
        ],
        password: [
          {
            required: true,
            message: this.$t('login.pleaseEnterNewPassword'),
            trigger: 'submit',
          },
        ],
        confirmPassword: [{ validator: validatePass2, trigger: 'submit' }],
      },
      iddTimeShow: false,
      shortMenuShow: false,
      bigHomeLangString: this.$i18n.locale == 'zh' ? '简体中文' : 'English',
      langString: '',
      iddSupFlag: false,
      customer: '',
      shopName: '',
      shopNameList: [],
      menuProductType: '',
      // PURCHASE_PAYMENT_finish:false,
      gridData: [],
      showingProduct: {},
      ledgerToBeDownloadedCount: '', // 资金方台账下载待处理数量
      showTopNotice:false
    }
  },
  computed: {
    ...mapGetters(['getDispositionMap']),
    ...mapState({
      listByEnterpriseId: state => state.user.listByEnterpriseId,
    }),
    productType() {
      return filterDictParam(
        this.$store.state.user.listByEnterpriseId?.[0]?.productType
      )
    },
    allMenuIds() {
      return this.showingProduct.children?.map(menu => menu.id)
    },
  },
  methods: {
    handleCfcaAgreementConfirm() {
      this.$message({
        type: 'success',
        showClose: true,
        message: this.$t('common.signedSuccessfully'),
      })
      this.cfcaAgreementDialogVisible = false
      this.contentWrapperKey += 1
    },
    handleCfcaAgreementCancel() {
      this.cfcaAgreementDialogVisible = false
    },
    async getNoticeShowFlag(){
      const res = await this.$API.system.getTopNoticeShow()
      this.showTopNotice = res.data.data
    },
    async handleCloseNotice(){
      // 接口关闭
      this.showTopNotice = false
      await this.$API.system.closeTopNotice()

    },
    // 处理滚动事件：判断是否触底
    handleScroll(e) {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      // 触底判断：滚动距离 + 可视高度 >= 总高度 - 100px（预留100px提前加载）
      const isBottom = scrollTop + clientHeight >= scrollHeight - 100;
      // 满足条件且有更多数据、不在加载中，触发加载更多
      if (isBottom && this.hasMore && !this.isLoadingMore) {
        this.loadMoreData(true);
      }
    },
    /**
     * 加载下载任务数据（支持初始化加载和加载更多）
     * @param {boolean} isLoadMore - 是否为加载更多操作，默认为false（初始化加载）
     */
    async loadMoreData(isLoadMore = false) {
      
      // 如果是加载更多且处于加载中状态，则直接返回
      if (isLoadMore && this.isLoadingMore) return;

      // 初始化加载时重置页码和数据
      if (!isLoadMore) {
        this.pageNum = 1;
        this.gridData = [];
        this.hasMore = true;
      } else {
        this.isLoadingMore = true; // 锁定状态，防止重复请求
        this.pageNum++; // 页码自增
      }

      try {
        // 调用后端接口加载数据
        const res = await this.$http.post('/kj-tools/kjLedgerDownloadInfo/getCurrentUserDownLoadTasks', {
          current: this.pageNum, // 当前页
          size: this.pageSize    // 每页条数
        });

        if (res.data.code === '200') {
          const records = res.data.data.records || []
          const newData = records.map(item => ({
            ...item,
            ...(item.status
              ? {
                  statusDisplay: JSON.parse(item.status).displayName,
                  statusKey: JSON.parse(item.status).dictParam,
                }
              : {}),
          }))

          // 处理数据
          if (isLoadMore) {
            // 加载更多：拼接新数据
            this.gridData = [...this.gridData, ...newData];
          } else {
            // 初始化加载：直接设置数据
            this.gridData = newData;
          }
          
          // 判断是否还有更多数据
          this.hasMore = res.data.data.total > this.gridData.length;
        }
      } catch (error) {
        console.error('加载数据失败', error);
        // 初始化加载失败时重置状态
        if (!isLoadMore) {
          this.hasMore = false;
        }
      } finally {
        this.isLoadingMore = false; // 解锁状态
      }
    },

    // 初始化加载数据
    async getCurrentUserDownLoadTasks() {
      await this.loadMoreData();
    },

    // ---------------------
    ...mapActions(['getCustomization']),
    filterDictParam,
    handleNotificationCount(notificationcountRes) {
      // this.ledgerToBeDownloadedCount = '10'
      this.ledgerToBeDownloadedCount = notificationcountRes.ledgerToBeDownloadedCount || ''
    },
    toProductCenter(){
      this.$router.push("/main-productCenter")
    },
    handleOpenProductCenter () {
      const obj = JSON.parse(JSON.stringify(this.pCenterList[0]))
      obj.hasChildren = true
      obj.children = this.pCenterList
      this.showingProduct = obj
      this.$router.push({path: '/main-productCenter'})
    },
    handlePopShow() {
      this.getCurrentUserDownLoadTasks()
    },
    async markDownloadedFunc ({id, markAllDownloaded = false}) {
      let params = {
        id,
        markAllDownloaded
      }
      const data = await this.$API.system.markDownloaded(params)
      var code = data.data.code;
      if (code == "200") {
        vm.$message.success(vm?.$t('preApprovalLogin.success'))

        // 手动标记为已下载
        this.gridData = this.gridData.map(item => {
          return {
            ...item,
            isDownload: "{\"dictParam\":\"YES\",\"displayName\":\"是\",\"dictKey\":\"Y\"}"  // 标记为已下载
          }
        })
      }
    },
    async handleDownload({ url, id }) {
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      document.body.appendChild(a)
      a.click()
      URL.revokeObjectURL(a.href)
      document.body.removeChild(a)

      this.markDownloadedFunc({id}) // 标记为已下载
    },
    // getCurrentUserDownLoadTasks() {
    //   this.downloadTableLoading = true
    //   this.$http
    //     .post('/kj-tools/kjLedgerDownloadInfo/getCurrentUserDownLoadTasks', { current: 1, size: 100 })
    //     .then(({data}) => {
    //       const records = data.data.records || []
    //       this.gridData = records.map(item => ({
    //         ...item,
    //         ...(item.status
    //           ? {
    //               statusDisplay: JSON.parse(item.status).displayName,
    //               statusKey: JSON.parse(item.status).dictParam,
    //             }
    //           : {}),
    //       }))
    //     })
    //     .catch(err => {
    //       console.error(err)
    //     })
    //     .finally(() => {
    //       this.downloadTableLoading = false
    //     })
    // },
    // 跳转到购物车
    goBuyCar() {
      this.$router.push({
        path: '/child-marketplacePortal/buyCar',
      })
    },
    //跳转到账户系统
    // 仅将原本逻辑移到util，未更改
    gotoAcc() {
      let fromUrl = window.location.origin
      let enterpriseId = sessionStorage.getItem('enterpriseId')
      let accUrl
      if (fromUrl.includes('localhost')) {
        accUrl = 'http://localhost:9090'
      } else if (fromUrl.includes('lianyirong.com.cn')) {
        accUrl = 'https://payment.lianyirong.com.cn'
      } else if (fromUrl.includes('qhhrly.cn')) {
        accUrl = 'https://payment.qhhrly.cn'
      } else if (fromUrl.includes('hrlyit.com')) {
        accUrl = 'https://payment.hrlyit.com'
      } else if (fromUrl.includes('wellschain.com')) {
        accUrl = 'https://payment.wellschain.com'
      } else {
        accUrl = 'https://payment.linklogis.com.hk'
      }
      if (fromUrl && enterpriseId && accUrl) {
        let url = `${accUrl}/#/jumpingLoading?fromUrl=${fromUrl}&enterpriseId=${enterpriseId}&lang=${this.$i18n.locale}`
        window.location.href = url
      } else {
        this.$alert('配置错误，请联系管理员', this.$t('login.tips'), {
          confirmButtonText: this.$t('login.confirm'),
        })
      }
    },
    //跳转到 DTT
    gotoDTT () {
      let enterpriseId = sessionStorage.getItem('enterpriseId')

      this.$API.system.getTokenUrl({enterpriseId}).then(({ data }) => {
        // const url = data.data
        // window.open(url, '_blank')

        const baseUrl = data.data
        // 获取当前完整地址作为return_domain
        const returnDomain = window.location.href
        const separator = baseUrl.includes('?') ? '&' : '?'
        const fullUrl = `${baseUrl}${separator}return_domain=${encodeURIComponent(returnDomain)}`
        
        window.open(fullUrl, '_blank')

      })
    },
    //修改
    jumpPath() {
      const res = this.$router.history.current.path
      const isJump = res?.split('/')
      if (isJump && isJump[1] !== 'child-efinancePortal') {
        return
      }
      this.$router.push({
        path:
          '/child-efinancePortal/page?design.projectCode=0a668c42f0724a0897a6b5415d193ae3&design.appCode=e9aa8c41588745eb8454f00c9e54e39f&design.appVersion=V1.0.0&design.menuCode=51890f36b6424f7ab2e8e6a73a748614',
      })
    },
    // 当前首页贸易角色；getCompany 中可能刚同步过默认角色，以本地存储为准
    getCurrentTradeRole() {
      return localStorage.getItem('tradeRole') || this.tradeRole
    },
    // 贸易角色仅剩一个时，切换入口已隐藏，默认选中该角色
    ensureSingleTradeRole() {
      if (this.tradeRoleList.length !== 1) return
      const onlyRole = this.tradeRoleList[0] && this.tradeRoleList[0].dictParam
      if (!onlyRole || this.getCurrentTradeRole() === onlyRole) return
      this.changeTradeRole(onlyRole)
    },
    // 切换贸易角色（Buyer / Supplier）
    async changeTradeRole(role) {
      if (this.tradeRole === role) return
      try {
        await setOrgRole(this.$http, role)
      } catch (e) {
        console.log(e)
      }
      localStorage.setItem('tradeRole', role)
      sessionStorage.setItem('tradeRole', role)
      this.tradeRole = role
      this.$setGlobalState({ tradeRole: role })
      // 菜单缓存属于旧角色，需清空后回首页按新角色重新定位菜单
      ;['currentProductNavs', 'curMenuIndex', 'curM3subActive', 'curMenuProductType', 'curMenuPath'].forEach(key =>
        sessionStorage.removeItem(key)
      )
      window.location.hash = '#/home'
      location.reload()
    },
    // 切换大首页语言
    changeLangBigHome(lang) {
      const langChanged = lang !== this.$i18n.locale
      localStorage.setItem('locale', lang)
      // 切换语言的时候保存当前菜单
      sessionStorage.setItem(
        'currentProductNavs',
        JSON.stringify(this.showingProduct)
      )
      this.$i18n.locale = lang
      console.log('this.$route.query.lang', this.$route)

      if (lang == 'zh') {
        this.bigHomeLangString = '简体中文'
      } else {
        this.bigHomeLangString = 'English'
      }
      //通知子应用更新
      this.$setGlobalState({ langlocale: lang })

      // 清除当前路由的lang，否则会影响后续语言切换
      const query = { ...this.$route.query };
      if (query.lang) {
        delete query.lang;
      }
      this.$router.replace({
        ...this.$route,
        query
      })

      // 语言已写入 locale，重载后请求头 Accept-Language 会带上新语言；
      // 角色列表改为重载后延期拉取（见 created 中 pendingTradeRoleRefresh 处理），
      // 避免 await 接口阻塞 reload，接口慢/无响应时语言切换不生效
      if (langChanged) {
        sessionStorage.setItem('pendingTradeRoleRefresh', '1')
      }

      // this.$router.go(0)
      location.reload()
    },
    //切换子应用语言
    /*     changeLang(lang) {
          if (lang == 'zh') {
            this.langString = '简体中文'
          } else {
            this.langString = 'English'
          }
          //通知子应用更新
          switch (this.currentProduct) {
            case 'idd':
              this.$setGlobalState({ iddLocal: lang })
              localStorage.setItem('iddLocal', lang)
              break
            case 'efinance':
              this.$setGlobalState({ efinanceLocal: lang })
              localStorage.setItem('efinanceLocal', lang)
              break
            default:
              break
          }
          this.$setGlobalState({ childLocale: lang })
        }, */
    //点击菜单外的
    clickoutsideFunShort() {
      this.shortMenuShow = false
    },
    clickoutsideFun() {
      this.navs.map(li => {
        li.selected = false
      })
    },
    clearMsgErr(formName) {
      this.resetErrMsg = ''
      if (typeof formName == 'string') {
        this.$refs[formName].clearValidate()
      }
    },
    //弹窗确定
    // compSure(data) {
    //   this.compName = data.entEnName || ''
    //   this.finishHome = true
    // },
    //弹窗关闭
    compClose() {
      this.showCompChoose = false
      this.$router.replace('/login')
    },
    //获取用户的基础信息
    async getUserInfo() {
      var _this = this
      // console.log(_this.$http,'=====更新==========');
      return new Promise((reslove, reject) => {
        _this.$http.post(`/kj-web/sys/getCurSysUser`).then(
          function(data) {
            let userObj = data.data.data || {}
            sessionStorage.setItem(
              'objCurUserInfo',
              JSON.stringify(data.data.data)
            )
            _this.userName = userObj.name || '-'
            reslove()
          },
          function(response) {
            // _this.$llsAlert({text: response});
            console.log(response)
            // _this.$alert(response, _this.$t('login.tips'), {
            //   confirmButtonText: _this.$t('login.confirm'),
            // })
            reject()
          }
        )
      })
    },
    //通过path查找当前菜单的对象
    getHightLightByPath(path) {
      let father = this.navs.filter(item => {
        return item.menuUrl == path
      })
      if (father && father.length > 0) {
        //一级菜单
        this.menuclick(father[0])
      } else {
        //二级菜单
        let children = []
        let childrenFather = []
        this.navs.map(item => {
          if (item.children && item.children.length > 0) {
            let child = item.children.filter(li => {
              return path.includes(item.menuUrl)
            })
            if (child && child.length > 0) {
              children = children.concat(child)
              childrenFather = childrenFather.concat(item)
            }
          }
        })
        if (children.length > 0) {
          // this.subMenuClick(children[0], childrenFather[0])
          childrenFather[0].children.map(li => {
            li.selected = false
          })
          children[0].selected = true
          childrenFather[0].selected = false
          this.menuIndex = childrenFather[0].id
          this.shortMenuIndex = childrenFather[0].id
          // this.menuIndex  = "1"
          this.shortMenuShow = false
        }
      }
    },
    //高亮菜单
    getHightLightByPathNOFlash(path, menuKey) {
      let father = this.navs.filter((item) => {
        return item.menuUrl == path
      })
      if (father && father.length > 0) {
        //一级菜单
        // this.menuclick(father[0]);
        this.menuIndex = father[0].id
        this.shortMenuIndex = father[0].id
      } else {
        //二级菜单
        let children = []
        let childrenFather = []
        if (menuKey) {
          let allRouterList = this.flatteningArr(this.navs)
          const currentRouter = allRouterList.filter((item) => {
            return item.projectCode === menuKey
          })
          if (currentRouter && currentRouter.length) {
            children.push(...currentRouter)
            childrenFather.push(...currentRouter)
          }
        } else {
          let allRouterList = this.flatteningArr(this.navs)
          let child = allRouterList.filter((li) => {
            return li.menuUrl == path
          })
          if (child && child.length > 0) {
            children = children.concat(child)
            childrenFather = childrenFather.concat(child)
          }
        }
        if (children.length > 0) {
          // this.subMenuClick(children[0], childrenFather[0]);
          this.menuIndex = childrenFather[0].id
          this.shortMenuIndex = childrenFather[0].id
        }
      }
    },
    flatteningArr(arr) {
      let arr1 = []
      arr.forEach((val) => {
        if (val.children instanceof Array && val.children.length) {
          arr1 = arr1.concat(this.flatteningArr(val.children))
        } else {
          arr1.push(val)
        }
      })
      return arr1
    },
    //跳转页面
    goPage() {
      //初始化3级menuIndex
      let curM3subActive = sessionStorage.getItem('curM3subActive')
      if (curM3subActive) {
        this.m3subActive = curM3subActive // 刷新菜单时重置字段
      } else {
        this.m3subActive = '' // 刷新菜单时重置字段
      }
      //初始化2级menuIndex
      let menuIndex = sessionStorage.getItem('curMenuIndex')
      if (menuIndex) {
        //刷新跳转路由
        this.menuIndex = menuIndex
        this.shortMenuIndex = menuIndex
      } else {
        const { fromAccount = '' } = this.$route.query
        if(fromAccount && fromAccount !== ''){
          // 非登录进来，从账户系统直接跳转过来的
          if(fromAccount === 'MORE10000'){
            this.showingProduct =  this.navsUser
          } else {
            this.showingProduct = this.navs.find(item=>(item.mapCode === fromAccount || item.menuCode === fromAccount)) || this.showingProduct
          } 
          this.$router.push({
            path:this.$route.path,
            query:this.$route.query || {}
          })
          let curMenuProductType = this.showingProduct.mapCode === 'MEUC9001' ? 'MARKET' : ''
          this.judgeProdType(curMenuProductType)
        } else if (this.$route.path && this.$route.path !== '/home') {
          // 新开窗口/直链进入：已有具体路由则保留，不强制跳首页
          this.keepDeepLinkRoute()
        } else {
          // 登录进来的情况
          // 首次进来页面跳转
          this.firstTimeRoute()
        }
        
      }
      //初始化产品类型
      let curMenuProductType = sessionStorage.getItem('curMenuProductType')
      if (curMenuProductType) {
        this.judgeProdType(curMenuProductType)
      }
    },
    // 直链进入时保留当前路由，仅同步产品与菜单高亮
    keepDeepLinkRoute() {
      const purePath = (this.$route.path || '').split('?')[0]
      const menuKey = this.$route.query.menuKey || ''
      const getAppPrefix = (p) => {
        const m = (p || '').match(/^\/(child-[^/]+|main-[^/]+)/)
        return m ? m[0] : ''
      }
      const pathPrefix = getAppPrefix(purePath)
      const matchMenuUrl = (menuUrl) => {
        const menuPath = (menuUrl || '').split('?')[0]
        if (!menuPath) return false
        if (purePath === menuPath) return true
        if (pathPrefix && getAppPrefix(menuPath) === pathPrefix) return true
        return false
      }
      let matchedProduct = null
      const productList = [...(this.navs || [])]
      if (this.navsUser && this.navsUser.children) {
        productList.push(this.navsUser)
      }
      for (const product of productList) {
        // 无子菜单且非DEFAULT的产品（如硬编码的My Unloq/More Product入口）无法渲染左侧菜单，跳过匹配
        if (!(product.menuProductType === 'DEFAULT' || (product.children && product.children.length))) continue
        const menus = [product, ...this.flatteningArr(product.children || [])]
        if (menus.some(item => matchMenuUrl(item.menuUrl))) {
          matchedProduct = product
          break
        }
      }
      if (matchedProduct) {
        // DEFAULT 类型(用户中心/产品中心)不保留原页面，直接跳默认首页，
        // 避免以单个节点为根渲染侧边栏导致菜单层级丢失
        if (
          matchedProduct.menuProductType === 'DEFAULT' &&
          this.navsUser &&
          this.navsUser.children
        ) {
          this.showingProduct = this.navsUser
          this.firstTimeRoute()
          return
        }
        this.showingProduct = matchedProduct
        this.judgeProdType(matchedProduct.menuProductType)
        sessionStorage.setItem('curMenuProductType', matchedProduct.menuProductType || '')
      }
      this.getHightLightByPathNOFlash(purePath, menuKey)
      if (this.menuIndex) {
        sessionStorage.setItem('curMenuIndex', this.menuIndex)
        this.shortMenuIndex = this.menuIndex
      }
      sessionStorage.setItem('curMenuPath', purePath)
    },

    //首次进来页面跳转
    firstTimeRoute() {
      this.judgeProdType(this.showingProduct.menuProductType)
      if (this.navs && this.navs.length > 0) {
        //判断是否有2级子菜单
        if (
          this.showingProduct.children &&
          this.showingProduct.children.length > 0
        ) {
          //判断是否有3级子菜单
          if (
            this.showingProduct.children[0].children &&
            this.showingProduct.children[0].children.length > 0
          ) {
            this.menuIndex = this.showingProduct.children[0].id
            this.shortMenuIndex = this.showingProduct.children[0].id
            this.m3subActive = this.showingProduct.children[0].children[0].id
            this.$router.push({
              path: this.showingProduct.children[0].children[0].menuUrl,
            })
          } else {
            //无3级菜单有2级菜单
            this.menuIndex = this.showingProduct.children[0].id
            this.shortMenuIndex = this.showingProduct.children[0].id
            const query = {}
            if (this.showingProduct.children[0].projectCode) {
              query.menuKey = this.showingProduct.children[0].projectCode
            }
             if (this.$route.query.productType) {
              query.productType = this.$route.query.productType
            }
            this.$router.push({
              path: this.showingProduct.children[0].menuUrl,
              query: query,
            })
          }
        } else {
          //无2级菜单有1级菜单
          this.menuIndex = this.showingProduct.id
          this.shortMenuIndex = this.showingProduct.id
          this.$router.push({ path: this.showingProduct.menuUrl })
        }
      } else {
        //无菜单
      }
    },
    // 获取产品中心列表
    async getProductCenterList(){
      var _this = this
      await _this.$http
        .post('/kj-web/sys/getGeneralMenuTreeList', { sysChannel: 'kj_my' })
        .then(
          data => {
            var code = data.data.code
            if (code == '200') {
              let tl = data.data.data || []
              tl = tl.filter(i => i.menuProductType !== 'BIG_HOME')
              tl = filterMenusByTradeRole(tl, this.getCurrentTradeRole(), ROLE_FILTER_EXEMPT_MENU_CODES)
              //深拷贝原始数
              //获取页面菜单
              let navs = []
              let allSysSourceList = [] // 菜单内所有按钮权限
              tl.map(item => {
                if (item.appCode) {
                  item.url =
                    item.url +
                    `?design.projectCode=${item.projectCode}&design.appCode=${item.appCode}&design.appVersion=${item.appVersion}&design.menuCode=${item.menuCode}`
                }
                let navObj = {
                  ...item,
                  //一级菜单处理
                  mainTitle: item.menuName || '',
                  name: item.name || '',
                  nameEn: item.nameEn || '',
                  icon: item.icon || 'idd-index-icon',
                  id: item.id && item.id.toString() || '',
                  menuUrl: item.url || '',
                  selected: false,
                  children: [],
                  menuProductType: item.menuProductType,
                  projectCode: item.projectCode || '',
                  sysSourceList: item?.sysSourceList || [],
                }
                if (item?.sysSourceList?.length) {
                  allSysSourceList = allSysSourceList.concat(
                    item?.sysSourceList
                  )
                }
                if (
                  item.menuCode === 'MEUCN9100' ||
                  item.menuCode === 'MEUCN9000'
                ) {
                  this.$setGlobalState({
                  exportDrawbackMenuList: item || {},
                })
                 localStorage.setItem(
                    'exportDrawbackMenuList',
                    JSON.stringify(item || {})
                 )
                }
                if (!item.children) {
                  //不存在二级菜单
                } else {
                  //存在二级菜单
                  item.children.map(li => {
                    if (li.appCode) {
                      li.url =
                        li.url +
                        `?design.projectCode=${li.projectCode}&design.appCode=${li.appCode}&design.appVersion=${li.appVersion}&design.menuCode=${li.menuCode}`
                    }
                    let navObjsub = {
                      name: li.menuName || '',
                      nameEn: li.menuEnName || '',
                      icon: li.icon || '',
                      menuUrl: li.url || '/',
                      id: li.id,
                      parentId: li.parentId,
                      selected: false,
                      children: [],
                      menuProductType: li.menuProductType,
                      projectCode: li.projectCode || '',
                      sysSourceList: li?.sysSourceList || [],
                    }
                    if (li?.sysSourceList?.length) {
                      allSysSourceList = allSysSourceList.concat(
                        li?.sysSourceList
                      )
                    }
                    if (!li.children) {
                      //不存在三级级菜单
                    } else {
                      //存在三级级菜单
                      li.children.map(three => {
                        if (three.appCode) {
                          three.url =
                            three.url +
                            `?design.projectCode=${three.projectCode}&design.appCode=${three.appCode}&design.appVersion=${three.appVersion}&design.menuCode=${three.menuCode}`
                        }
                        let navObjsubthree = {
                          name: three.menuName || '',
                          nameEn: three.menuEnName || '',
                          menuUrl: three.url || '/',
                          id: three.id,
                          parentId: li.parentId,
                          selected: false,
                          children: [],
                          menuProductType: three.menuProductType,
                          projectCode: three.projectCode || '',
                          sysSourceList: three?.sysSourceList || [],
                        }
                        if (three?.sysSourceList?.length) {
                          allSysSourceList = allSysSourceList.concat(
                            three?.sysSourceList
                          )
                        }
                        if (!three.children) {
                          // 不存在四级菜单
                        } else {
                          // 存在四级菜单
                          three.children.map(four => {
                            if (four.appCode) {
                              four.url =
                                four.url +
                                `?design.projectCode=${four.projectCode}&design.appCode=${four.appCode}&design.appVersion=${four.appVersion}&design.menuCode=${four.menuCode}`
                            }
                            let navObjsubfour = {
                              name: four.menuName || '',
                              nameEn: four.menuEnName || '',
                              menuUrl: four.url || '/',
                              id: four.id,
                              parentId: li.parentId,
                              selected: false,
                              menuProductType: four.menuProductType,
                              projectCode: four.projectCode || '',
                              sysSourceList: four?.sysSourceList || [],
                            }
                            navObjsubthree.children.push(navObjsubfour)
                            if (four?.sysSourceList?.length) {
                              allSysSourceList = allSysSourceList.concat(
                                four?.sysSourceList
                              )
                            }
                          })
                        }
                        navObjsub.children.push(navObjsubthree)
                      })
                    }
                    navObj.children.push(navObjsub)
                  })
                }
                navs.push(navObj)
              })
              this.productList = []
              navs.forEach(item => {
                if (item.menuProductType !== 'DEFAULT') {
                  // 产品中心菜单
                  this.productList.push(item)
                }
              })
            } else {
              _this.$alert(data.data.msg, '提示', {
                confirmButtonText: '确定',
              })
            }
          })
    },
    //获取菜单
    async getMenu() {
      this.menuHide = false
      var _this = this
      await _this.$http
        .post('/kj-web/sys/getUserMenuTreeList', { sysChannel: 'kj_my' })
        .then(
          data => {
            var code = data.data.code
            if (code == '200') {
              // _this.$router.push('/login');
              let tl = data.data.data || []
              tl = tl.filter(i => i.menuProductType !== 'BIG_HOME')
              tl = filterMenusByTradeRole(tl, this.getCurrentTradeRole(), ROLE_FILTER_EXEMPT_MENU_CODES)
              // let tl = navTest
              //深拷贝原始数
              //获取页面菜单
              let navs = []
              let allSysSourceList = [] // 菜单内所有按钮权限
              //先处理一级菜单
              // {
              //     "name": "单据管理",
              //     "icon": 'idd-bill-icon',
              //     "id": 1,
              //     "menuUrl":"/child-iDDPortal/documentManagement",
              //     selected:false,
              //     "children" : [],
              //
              // },
              tl.map(item => {
                //低代码页面url处理
                //page?design.projectCode=0a668c42f0724a0897a6b5415d193ae3&design.appCode=faae84d2d42e469ea5f52f82c561b1aa&design.appVersion=V1.0.0&design.menuCode=c6bb532763fd48f89718c1ae4c274066
                if (item.appCode) {
                  item.url =
                    item.url +
                    `?design.projectCode=${item.projectCode}&design.appCode=${item.appCode}&design.appVersion=${item.appVersion}&design.menuCode=${item.menuCode}`
                }
                // if (item.url == '/bigHome') {
                //   this.menuIndex = item.id
                // }
                let navObj = {
                  ...item,
                  //一级菜单处理
                  mainTitle: item.menuName || '',
                  name: item.menuName || '',
                  nameEn: item.menuEnName || '',
                  icon: item.icon || 'idd-index-icon',
                  id: item.id.toString(),
                  menuUrl: item.url || '',
                  selected: false,
                  children: [],
                  menuProductType: item.menuProductType,
                  projectCode: item.projectCode || '',
                  sysSourceList: item?.sysSourceList || [],
                }
                if (item?.sysSourceList?.length) {
                  allSysSourceList = allSysSourceList.concat(
                    item?.sysSourceList
                  )
                }
                if (
                  item.menuCode === 'MEUCN9100' ||
                  item.menuCode === 'MEUCN9000'
                ) {
                  this.$setGlobalState({
                  exportDrawbackMenuList: item || {},
                })
                 localStorage.setItem(
                    'exportDrawbackMenuList',
                    JSON.stringify(item || {})
                 )
                }
                if (!item.children) {
                  //不存在二级菜单
                } else {
                  //存在二级菜单
                  item.children.map(li => {
                    if (li.appCode) {
                      li.url =
                        li.url +
                        `?design.projectCode=${li.projectCode}&design.appCode=${li.appCode}&design.appVersion=${li.appVersion}&design.menuCode=${li.menuCode}`
                    }
                    let navObjsub = {
                      name: li.menuName || '',
                      nameEn: li.menuEnName || '',
                      icon: li.icon || '',
                      menuUrl: li.url || '/',
                      id: li.id,
                      parentId: li.parentId,
                      selected: false,
                      children: [],
                      menuProductType: li.menuProductType,
                      projectCode: li.projectCode || '',
                      sysSourceList: li?.sysSourceList || [],
                    }
                    if (li?.sysSourceList?.length) {
                      allSysSourceList = allSysSourceList.concat(
                        li?.sysSourceList
                      )
                    }
                    if (!li.children) {
                      //不存在三级级菜单
                    } else {
                      //存在三级级菜单
                      li.children.map(three => {
                        if (three.appCode) {
                          three.url =
                            three.url +
                            `?design.projectCode=${three.projectCode}&design.appCode=${three.appCode}&design.appVersion=${three.appVersion}&design.menuCode=${three.menuCode}`
                        }
                        let navObjsubthree = {
                          name: three.menuName || '',
                          nameEn: three.menuEnName || '',
                          menuUrl: three.url || '/',
                          id: three.id,
                          parentId: li.parentId,
                          selected: false,
                          children: [],
                          menuProductType: three.menuProductType,
                          projectCode: three.projectCode || '',
                          sysSourceList: three?.sysSourceList || [],
                        }
                        if (three?.sysSourceList?.length) {
                          allSysSourceList = allSysSourceList.concat(
                            three?.sysSourceList
                          )
                        }
                        if (!three.children) {
                          // 不存在四级菜单
                        } else {
                          // 存在四级菜单
                          three.children.map(four => {
                            if (four.appCode) {
                              four.url =
                                four.url +
                                `?design.projectCode=${four.projectCode}&design.appCode=${four.appCode}&design.appVersion=${four.appVersion}&design.menuCode=${four.menuCode}`
                            }
                            let navObjsubfour = {
                              name: four.menuName || '',
                              nameEn: four.menuEnName || '',
                              menuUrl: four.url || '/',
                              id: four.id,
                              parentId: li.parentId,
                              selected: false,
                              menuProductType: four.menuProductType,
                              projectCode: four.projectCode || '',
                              sysSourceList: four?.sysSourceList || [],
                            }
                            navObjsubthree.children.push(navObjsubfour)
                            if (four?.sysSourceList?.length) {
                              allSysSourceList = allSysSourceList.concat(
                                four?.sysSourceList
                              )
                            }
                          })
                        }
                        navObjsub.children.push(navObjsubthree)
                      })
                    }
                    navObj.children.push(navObjsub)
                  })
                }
                navs.push(navObj)
              })

              // 产品中心菜单
              this.pCenterList = navs.filter(item => item.menuProductType == 'DEFAULT')
              
              this.navs = this.mapTopbarProductList(navs)
              this.navsUser = []
              this.navsSwitch = []
              const navsUserTemp = []
              this.navs.forEach(item => {
                if (item.menuProductType === 'DEFAULT') {
                  // 产品中心菜单
                  navsUserTemp.push(item)
                } else {
                  this.navsSwitch.push(item)
                }
              })
              if (navsUserTemp.length > 0) {
                // 构造数据
                this.navsUser = {
                  "id": "",
                  "menuCode": "MORE10000",
                  "menuName": "产品中心",
                  "icon": "idd-doc",
                  "parentId": "-1",
                  "url": "/main-productCenter",
                  "orderNo": 0,
                  "menuEnName": "Product Center",
                  "hasChildren": false,
                  "menuProductType": "DEFAULT",
                  "sysChannel": "kj_my",
                  "mainTitle": "产品中心",
                  "name": "产品中心",
                  "nameEn": "Product Center",
                  "menuUrl": "/main-productCenter",
                  "selected": false,
                  "children": [],
                  "projectCode": "",
                  "sysSourceList": [],
                  children: navsUserTemp
                }
              } else {
                this.navsUser = []
              }

              // 缓存有效（有子菜单或为DEFAULT）才取缓存，否则取第一个菜单；坏快照自动丢弃
              let cachedProduct = null
              try {
                cachedProduct = JSON.parse(sessionStorage.getItem('currentProductNavs') || 'null')
              } catch (e) {}
              const isValidProduct = (p) =>
                p && (p.menuProductType === 'DEFAULT' || (p.children && p.children.length))
              this.showingProduct = isValidProduct(cachedProduct)
                ? cachedProduct
                : (navsUserTemp.length > 0 ? this.navsUser : this.navsSwitch[0] || {})
              try {
                this.$setGlobalState({
                  currentPageBtnPermission: allSysSourceList || [],
                })
                localStorage.setItem(
                  'currentPageBtnPermission',
                  JSON.stringify(allSysSourceList)
                )
              } catch (error) {
                console.log(error)
              }
              let isReFlag = this.$route.query.isReFlag || 0
              if (['1', '2'].includes(isReFlag)) {
                if (isReFlag == 2) {
                  this.$router.push('/child-accountSettingPortal/bindStore')
                  this.getHightLightByPathNOFlash(
                    '/child-accountSettingPortal/authorizationCenter',
                    ''
                  )
                }
              } else {
                this.goPage()
              }
            } else {
              // $.fn.mAlert('body',{tips:data.data.msg});
              _this.$alert(data.data.msg, '提示', {
                confirmButtonText: '确定',
              })
            }
          },
          function(response) {
            // $.fn.mAlert('body',{tips:response});
            _this.$alert(response, '提示', {
              confirmButtonText: '确定',
            })
          }
        )
      await _this.$http.post('/kj-sys/user/whetherShowCommonMenu').then(res => {
        this.navsBtnShow = res.data.data
      })
      this.compName = ''
      this.menuHide = true
    },
    mapTopbarProductList(navs){
      let res = []
      res = navs.map(item=>{
        const matchItem = navsValueList.filter(nItem=>item.menuCode === nItem.mapCode)
        if(matchItem.length){
          return {
            ...item,
            ...matchItem[0]
          }
        }else {
          return item
        }
      })
      res.unshift(navsValueList[0])
      res.push(navsValueList[navsValueList.length - 1])
      return res
    },
    //菜单语言切换

    getCookie(name) {
      const match = document.cookie.match(
        new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
      )
      return match ? decodeURIComponent(match[1]) : ''
    },
    setOrgCookie(enterpriseId) {
      if (!enterpriseId) return
      document.cookie = 'llskjorg=' + enterpriseId + ';path=/;'
    },
    //获取企业信息
    async getCompany() {
      // const result = await this.$http.post('/kj-web/sys/getEnterpriseVO')
      const result = await this.$http
        .post('/kj-sys/kjEnterprise/getEnterpriseByType', {
          productType: [
            'IDD',
            'DOC_EXCHANGE',
            'PURCHASE_PAYMENT',
            'E_FINANCE',
            'MARKET',
            'DIGIPO',
            'EXPORT_DRAWBACK_PROD',
            'EXPORT_DRAWBACK_TRADE',
            'DEFAULT_PRODUCT',
            'ACCOUNT',
          ],
        })
        .then(
          async ({ data }) => {
            if (data.code == '200') {
              const tl = data.data || []

              const cachedId = sessionStorage.getItem('enterpriseId')
              let localId = ''
              try {
                localId = localStorage.getItem('enterpriseId') || ''
              } catch (e) {
                localId = ''
              }
              const cookieOrgId = this.getCookie('llskjorg')
              // 直链/新窗口无 session：优先 localStorage/cookie 里上次选中的企业，再兜底列表首个
              let enterpriseId = cachedId || localId || cookieOrgId || tl[0].id
              let matched =
                tl.find(item => String(item.id) === String(enterpriseId)) || tl[0]
              enterpriseId = matched.id

              const needSyncOrg = !cachedId || String(cachedId) !== String(enterpriseId)
              sessionStorage.setItem('enterpriseId', enterpriseId) // dyy 企业id
              try {
                localStorage.setItem('enterpriseId', enterpriseId)
              } catch (e) {}
              sessionStorage.setItem(
                'companyName',
                matched.companyName || sessionStorage.getItem('companyName') || ''
              ) // dyy 企业名字
              sessionStorage.setItem(
                'companyIdentCode',
                matched.companyIdentCode || ''
              ) // dyy 企业code
              if (matched.enterpriseRole != null && matched.enterpriseRole !== '') {
                sessionStorage.setItem('enterpriseRole', matched.enterpriseRole)
              }

              this.shopNameList = this.userCompanyList = tl

              // 直链/新窗口补齐服务端企业上下文（与选企业 chooseFinal 对齐）
              if (needSyncOrg && enterpriseId) {
                try {
                  await this.$http.get(`/kj-web/sys/setOrgId?orgId=${enterpriseId}`)
                  this.setOrgCookie(enterpriseId)
                  await syncTradeRoleAfterSetOrg(this.$http)
                } catch (e) {
                  console.log(e)
                }
              }
              // 内管端有且只有一个企业
              // tl.map(item=>{
              //     this.userName = item.entCnName || ''
              // })
              // if (tl.length > 1) {
              //   this.userCompanyList = tl
              //   return false
              // } else {
              //   if (tl.length == 1) {
              //     this.compName = tl[0].entEnName || ''
              //   }
              //   return true
              // }
            } else {
              this.$alert(data.msg, this.$t('login.tips'), {
                confirmButtonText: this.$t('login.confirm'),
              })
              return false
            }
          },
          response => {
            // this.$alert(response, this.$t('login.tips'), {
            //   confirmButtonText: this.$t('login.confirm'),
            // })
            return false
          }
        )
      return result
    },
    closeAllPopovers() {
      // 确保所有三级菜单弹窗关闭
      Object.keys(this.$refs).forEach(key => {
        if (key.startsWith('popoverRef') && this.$refs[key]) {
          const popover = this.$refs[key][0] || this.$refs[key];
          if (popover && typeof popover.doClose === 'function') {
            popover.doClose();
          }
        }
      })
    },
    subMenuClick(item, table) {
      this.m3subActive = item.id
      sessionStorage.setItem('curM3subActive', this.m3subActive)
      if (!item.children) {
        //说明是三级菜单，让二级菜单高亮
        this.menuIndex = table.id
        sessionStorage.setItem('curMenuIndex', this.menuIndex)
      } else {
        //说明没有三级菜单，自身高亮
        this.menuIndex = item.id
        sessionStorage.setItem('curMenuIndex', this.menuIndex)
      }
      this.shortMenuIndex = item.id
      if (item.menuUrl) {
        const query = {}
        if (item.projectCode) {
          query.menuKey = item.projectCode
        }
        this.$router.push({
          path: item.menuUrl,
          query: query,
        })
        sessionStorage.setItem('curMenuPath', item.menuUrl)
        this.menuProductType = item.menuProductType
        sessionStorage.setItem('curMenuProductType', table.menuProductType)
        this.judgeProdType(this.menuProductType)
      }
      this.shortMenuShow = false
      // 关闭 popover 三级菜单弹窗
      this.$nextTick(() => {
        this.closeAllPopovers()
      })
    },
    menuclick(table, productData) {
      // if (table.menuProductType == 'ACCOUNT') {
      //   //账户系统不需要跳转路由
      //   this.gotoAcc()
      //   return
      // }
      if (productData && JSON.stringify(productData) !== '{}') {
        this.switchProduct(productData)
      }
      if (table.menuUrl && table.children.length == 0) {
        const query = {}
        if (table.projectCode) {
          query.menuKey = table.projectCode
        }
        this.$router.push({
          path: table.menuUrl,
          query: query,
        })
        sessionStorage.setItem('curMenuPath', table.menuUrl)
        this.menuProductType = table.menuProductType
        sessionStorage.setItem('curMenuProductType', table.menuProductType)
        this.judgeProdType(this.menuProductType)
      }
      this.menuIndex = table.id
      this.shortMenuIndex = table.id
      sessionStorage.setItem('curMenuIndex', this.menuIndex)
      //初始化3级index
      this.m3subActive = ''
      sessionStorage.setItem('curM3subActive', '')
      this.shortMenuShow = false
      console.log(this.navs, '===更新')
    },
    selectMenu(key, keyPath) {},
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    setPageH() {
      var hei = this.getSrcollHeight()
      let hString = `calc(100vh - ${80}px)`
      $('#main').css('height', hString)
    },
    //获取当前企业的产品信息
    getProductInfo() {
      return new Promise((resolve, reject) => {
        let enterpriseId = sessionStorage.getItem('enterpriseId')
        this.$API.enterprise.getProductByEnterpriseId(enterpriseId).then(
          data => {
            this.shopName =
              this.$i18n.locale == 'zh'
                ? data.data.data?.companyNameCn || data.data.data?.companyName
                : data.data.data?.companyName || data.data.data?.companyNameCn
            const result = data.data.data
            sessionStorage.setItem('enterpriseRole', result.enterpriseRole)
            sessionStorage.setItem(
              'enterpriseLocation',
              result.enterpriseLocation
            )
            resolve()
          },
          err => {
            reject()
          }
        )
      })
    },
    //页面初始化
    initPage: async function() {
      try {
        var hei = this.getSrcollHeight()
        let hString = `calc(100vh - ${80}px)`
        $('#main').css('height', hString)
        var logoArr = []
        for (var i = 0; i < 18; i++) {
          logoArr.push(i)
        }
        this.bglogoArr = logoArr
        //获取用户信息
        await this.getUserInfo()
        await this.getCompany()
        //获取企业产品信息
        await this.getProductInfo()
        
        //获取企业信息
        let flag = await this.getCompany()
        await this.getMenu()
        await this.getProductCenterList()
        await this.queryCfcaAgreement()
      } catch(e){
        console.log(e)
      } finally {
        //显示路由组件
        this.finishHome = true
        this.compName = ''
      }
      
      
    },
    async queryCfcaAgreement() {
      const res = await this.$API.system.queryCfcaAgreement()
      this.cfcaAgreementDialogVisible = Boolean(res.data.data)
      if (this.cfcaAgreementDialogVisible) {
        const d = res.data.data || {}
        this.cfcaAggrementId = d.id || ''
        this.cfcaTemplatePath = d.cfcaTemplatePath || ''
      } else {
        this.cfcaAggrementId = ''
        this.cfcaTemplatePath = ''
      }
    },
    //字典存储在session
    setSessionStorage() {
      let _this = this
      var objUser = JSON.parse(sessionStorage.getItem('objUser'))
      // this.userName = objUser.name;
      this.$http.post('/kj-web/dict/getAllDictList').then(
        function(data) {
          let DictList = data.data.data || []
          for (let i = 0; i < DictList.length; i++) {
            sessionStorage.setItem(
              DictList[i].dispalyName + '' + DictList[i].dictCode,
              JSON.stringify(DictList[i].subDictList)
            )
          }
          // _this.$setGlobalState({eventName:'allDictChange'});
        },
        function(response) {
          console.log('请求失败')
        }
      )
    },
    // 切换中英文调用枚举接口
    againSetSessionStorage() {
      let _this = this
      var objUser = JSON.parse(sessionStorage.getItem('objUser'))
      // this.userName = objUser.name;
      this.$http.post('/kj-web/dict/getAllDictList').then(
        function(data) {
          let DictList = data.data.data || []
          for (let i = 0; i < DictList.length; i++) {
            sessionStorage.setItem(
              DictList[i].dispalyName + '' + DictList[i].dictCode,
              JSON.stringify(DictList[i].subDictList)
            )
          }
          _this.$setGlobalState({ eventName: 'allDictChange' })
          // _this.$setGlobalState({eventName:''});
        },
        function(response) {
          console.log('请求失败')
        }
      )
    },
    againSetSessionStorageChild() {
      let _this = this
      var objUser = JSON.parse(sessionStorage.getItem('objUser'))
      // this.userName = objUser.name;
      this.$http
        .request({
          url: '/kj-web/dict/getAllDictList',
          method: 'post',
          childHead: true,
        })
        .then(
          function(data) {
            let DictList = data.data.data || []
            for (let i = 0; i < DictList.length; i++) {
              sessionStorage.setItem(
                DictList[i].dispalyName + '' + DictList[i].dictCode,
                JSON.stringify(DictList[i].subDictList)
              )
            }
            _this.$setGlobalState({ eventName: 'allDictChange' })
            // _this.$setGlobalState({eventName:''});
          },
          function(response) {
            console.log('请求失败')
          }
        )
    },
    //退出登录SSO
    async logoutSSO() {
      let res = await this.$sso.logout()
      if (res.code === '200') {
        // localStorage.clear()
        sessionStorage.clear()
        this.$router.replace('/login')
      }
    },
    //退出登录
    async logout() {
      var _this = this
      // _this.$router.push('/login');
      // _this.$http.post(
      //     "/kj-web/account/logout",
      // ).then(function(data){
      //     var code = data.data.code;
      //     if(code == "200") {
      //         sessionStorage.clear()
      //         _this.$router.replace('/login');
      //     } else {
      //         // $.fn.mAlert('body',{tips:data.data.msg});
      //         _this.$alert(data.data.msg, '提示', {
      //             confirmButtonText: '确定',
      //         });
      //     }
      // },function(response){
      //     // $.fn.mAlert('body',{tips:response});
      //     _this.$alert(response, '提示', {
      //         confirmButtonText: '确定',
      //     });
      // })
      try {
        var res = await this.$sso.logout()
        if (res) {
          // 登出成功
          this.$message({
            type: 'success',
            message: this.$t('login.logoutSuccessful'),
          })
          this.$router.replace('/login')
        }
        localStorage.clear()
      } catch (e) {
        console.log(e)
        var obj = JSON.parse(e.message)
        this.$message.error(obj.message)
      }
    },
    //重置密码
    resetPwd: function() {
      this.isResetPwd = true
      this.resetErrMsg = ''
      this.formReset = {
        confirmPassword: '',
        oldPassword: '',
        password: '',
      }
    },
    //关闭重置密码
    toClose: function() {
      this.isResetPwd = false
      this.$refs['formReset'].resetFields()
    },
    //确定重置密码
    toReset: function(formName) {
      let _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          // alert('submit!');
          _this.sureResetPwd()
          // this.cancleRe('ReSetruleForm')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //重置密码
    async sureResetPwd() {
      let _this = this
      let oldPassword = this.formReset.oldPassword
      let password = this.formReset.password
      let confirmPassword = this.formReset.confirmPassword
      let loginName = JSON.parse(sessionStorage.getItem('objCurUserInfo')).email
      try {
        let params = {
          loginName: loginName,
          password: password, //新密码
          orcPassword: oldPassword,
          sysChannel: 'kj_my_pc',
        }
        let res = await this.$sso.resetPasswd(params)
        if (res.code == '200') {
          _this.isResetPwd = false
          // 重置成功，请重新登录
          _this.$alert(
            _this.$t('login.resetSuccessfullyAgain'),
            _this.$t('login.tips'),
            {
              confirmButtonText: _this.$t('login.confirm'),
              callback: action => {
                _this.logout()
              },
            }
          )
        } else {
          // 暂无响应，请联系管理员
          _this.resetErrMsg =
            data.body.msg ||
            data.body.message ||
            _this.$t('login.serverNotRsponding')
        }
      } catch (e) {
        _this.resetErrMsg =
          JSON.parse(e.message).message || _this.$t('login.serverNotRsponding')
      }
      // _this.$http.post(
      //     `/kj-web/account/resetPwd?confirmPassword=${confirmPassword}&oldPassword=${oldPassword}&password=${password}`,{},{handingResponseErrMsg:true}
      // ).then(function(data){
      //     var code = data.data.code;
      //     if(code == "200") {
      //         _this.$alert('重置成功，请重新登录', '提示', {
      //             confirmButtonText: '确定',
      //             callback: action => {
      //                 _this.logout()
      //             }
      //         });
      //
      //     } else {
      //         _this.resetErrMsg = data.data.msg || data.data.message || '暂无响应，请联系管理员'
      //     }
      // },function(response){
      //     _this.resetErrMsg = response || '暂无响应，请联系管理员'
      // })
    },
    //获取时间倒计时时间戳
    getTime() {
      var _this = this
      // _this.$router.push('/login');
      _this.$http.post('/kj-idd/marketSetting/getRemainingCloseTime').then(
        function(data) {
          var code = data.data.code
          if (code == '200') {
            // _this.$router.replace('/login');
            if (data.data.data) {
              _this.countDown(data.data.data)
            }
            // _this.countDown(50000)
          } else {
            // $.fn.mAlert('body',{tips:data.data.msg});
            _this.$alert(data.data.msg, _this.$t('login.tips'), {
              confirmButtonText: _this.$t('login.confirm'),
            })
          }
        },
        function(response) {
          // $.fn.mAlert('body',{tips:response});
          _this.$alert(response, _this.$t('login.tips'), {
            confirmButtonText: _this.$t('login.confirm'),
          })
        }
      )
    },
    //带天数的倒计时
    countDown: function(times) {
      // var timer = null;
      let _this = this
      times = times / 1000
      clearInterval(_this.timer)
      _this.timer = null
      _this.timer = setInterval(function() {
        var day = 0,
          hour = 0,
          minute = 0,
          second = 0 //时间默认值
        if (times > 0) {
          day = Math.floor(times / (60 * 60 * 24))
          hour = Math.floor(times / (60 * 60)) - day * 24
          minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60
          second =
            Math.floor(times) -
            day * 24 * 60 * 60 -
            hour * 60 * 60 -
            minute * 60
        }
        if (day <= 9) day = '0' + day
        if (hour <= 9) hour = '0' + hour
        if (minute <= 9) minute = '0' + minute
        if (second <= 9) second = '0' + second
        //
        // console.log(day + "天:" + hour + "小时：" + minute + "分钟：" + second + "秒");
        _this.timeObj = {
          hour,
          minute,
          second,
        }
        times--
      }, 1000)
      if (times <= 0) {
        clearInterval(_this.timer)
        _this.timer = null
      }
    },
    changeShop(item) {
      try {
        sessionStorage.removeItem('currentProductNavs')
      } catch (error) {
        console.log(error)
      }
      this.$refs.shopDropdownRef && this.$refs.shopDropdownRef.hide()
      this.$nextTick(() => {
        this.$refs.companyDialogRef.getCompList(item)
        this.compName = ''
        this.shopNameList = this.userCompanyList
      })
    },
    // 显示隐藏三级菜单
    showSubPopper(id, shortMenu = false) {
      if (id === null) {
        document.querySelectorAll('.el-popover').forEach(el => {
          el.__vue__.$parent.doClose()
        })
        return
      }
      if (this.$refs[`popoverRef${id}`] == undefined) return
      const refs = shortMenu
        ? this.$refs[`popoverRef${id}`][1]
        : this.$refs[`popoverRef${id}`][0]
      setTimeout(() => {
        refs.doShow()
      }, 0)
    },
    filterShopName(value) {
      if (!value) {
        this.shopNameList = this.userCompanyList
        return
      }
      let ObjKey = this.$i18n.locale === 'zh' ? 'companyNameCn' : 'companyName' 
      this.shopNameList = this.userCompanyList
        .map(v => {
          if ((v[ObjKey] || v.locationName).includes(value)) {
            return v
          }
        })
        .filter(v => v)
    },
    //判断菜单的产品类型
    judgeProdType(menuProductType) {
      console.log(
        '🚀 ~ file: home.vue:2130 ~ judgeProdType ~ menuProductType:',
        menuProductType
      )
      // let menuProductType =  menu.menuProductType
      //初始化
      this.iddSupFlag = false
      this.iddTimeShow = false
      this.addCartShow = false // 如果不是market，不展示购物车入口
      switch (menuProductType) {
        case 'BIG_HOME':
          //大首页不需要处理保持现状
          break
        case 'MARKET': {
          //重置语言
          this.$setGlobalState({ childLocale: 'en' })
          //当存在二级资金方才展示购物车入口
          const marketFund = this.$store.state.user.listByEnterpriseId.filter(
            item =>
              item.enterpriseRole &&
              JSON.parse(item.enterpriseRole)?.dictParam == 'FUND' &&
              item.productType &&
              JSON.parse(item.productType)?.dictParam == 'MARKET'
          )
          if (marketFund.length > 0) {
            this.addCartShow = true
          }
          break
        }
        case 'PURCHASE_PAYMENT':
          //重置语言
          this.$setGlobalState({ childLocale: 'en' })
          break
        case 'DOC_EXCHANGE':
          //重置语言
          this.$setGlobalState({ childLocale: 'en' })
          break
        case 'GO_EARLY':
          //重置语言
          this.$setGlobalState({ childLocale: 'en' })
          break
        case 'ACCOUNT':
          //跳转页面
          break
        case 'IDD':
          //显示倒计时
          this.iddTimeShow = true
          this.getTime()
          //重置语言
          let iddNavs = this.navs.filter(item => {
            return item.menuProductType == 'IDD'
          })
          if (iddNavs[0]?.children && iddNavs[0]?.children.length >= 3) {
            //买方
            this.iddSupFlag = false
            this.$setGlobalState({ childLocale: 'en' })
            localStorage.setItem('iddLocal', 'en')
          } else {
            this.iddSupFlag = true
          }
          break
        default:
          this.$setGlobalState({ childLocale: 'en' }) //默认中文
          this.iddSupFlag = false
          this.iddTimeShow = false
          break
      }
    },
    switchProduct(product) {
      if(product.mapCode === 'MORE10000') {
        // 跳产品中心初始化左侧用户菜单栏
        this.showingProduct = this.navsUser
      } else {
        this.showingProduct = product
      }
      
      this.firstTimeRoute()
    },
    switchProductByMenuCode(menuCode) {
      const product = this.productList.find(v => v.menuCode === menuCode)
      if (product && product.menuProductType == 'ACCOUNT') {
        //账户系统不需要跳转路由
        this.gotoAcc()
        return
      }
      if (menuCode === 'DTT') {
        // DTT 不需要跳转路由
        this.gotoDTT()
        return
      }
      this.$refs.switchProductRef.currentProduct = product
      let { name, nameEn, icon } = product
      this.$refs.switchProductRef.currentProductName = this.$i18n.locale === 'en' ? nameEn : name

      this.switchProduct(product)
    },
    //监听页面刷新或者关闭
    // updateHandler() {

    //   console.log('页面刷新');
    //   let flashPath = this.$route.path
    //   let flashPathName = this.$route.name
    //   sessionStorage.setItem('flashPath',flashPath)
    //   sessionStorage.setItem('flashPathName',flashPathName)
    // },
  },
  watch: {
    //view层的全局监听
    $route: function(val, oldVal) {
      // console.log('当前URL当前URL当前URL当前URL========',val,oldVal);
      // this.getHightLightByPathNOFlash(val.path)
    },
    showingProduct: {
      handler(newValue) {
        sessionStorage.setItem('currentProductNavs', JSON.stringify(newValue))
      },
      deep: true,
    },
    //企业菜单的产品变化
    // menuProductType:(val,oldVal)=>{
    //   console.log('menuProductType',val,this.menuProductType);
    //   if(val =='GO_EARLY' ){
    //     //电商融资
    //   }else if(val =='IDD' ){

    //   }
    // }
  },
  beforeDestroy() {
    const tableBody = this.$refs.tableRef.$el.querySelector('.el-table__body-wrapper');
    tableBody.removeEventListener('scroll', this.handleScroll);
  },
  created() {
    // 获取顶部notice栏的通知--API
    this.getNoticeShowFlag()  
  },
  mounted() {
    this.$nextTick(() => {
      // 获取表格内容滚动容器
      const tableBody = this.$refs.tableRef.$el.querySelector('.el-table__body-wrapper');
      // 绑定滚动事件
      tableBody.addEventListener('scroll', this.handleScroll);
    });
    // 初始化时获取 query 字段设置语言, eg：从账户系统跳转
    const lang = this.$route.query.lang
    if (lang && lang !== this.$i18n.locale) {
      this.changeLangBigHome(lang)
    }

    this.initPage()
    this.setSessionStorage()
    this.getCustomization()
    // this.getEnterprise()
    window.onresize = () => {
      return (() => {
        // if(flag){
        //     flag =  false
        //     _this.setPageH()
        //     setTimeout(()=>{
        //         flag = true
        //     },1000)
        //     console.log('11111111111111')
        //     window.location.reload()
        // }
      })()
    }
    console.log('父应用Home')
    window.vm.$on('childRouteChange', (val) => {
      // console.log('子路由变化了',val);
      const params = val.split('?')
      let path = params && params[0]
      const menuKey = params.length === 2 && params[1].split('=')?.[1]
      // this.routeQuery = val.split('?')[1]
      // console.log(val,'===实际路由===',path);
      this.getHightLightByPathNOFlash(path, menuKey)
      // this.getHightLightByPath(path);
    })
    window.vm.$on('langChange', (val) => {
      // debugger
      // console.log('子路由变化了',this.$route);
      if (this.$route.path.includes('login')) {
      } else {
        this.againSetSessionStorage()
        // this.getMenu();
      }
      let path = val?.split('?')[0]
      // this.routeQuery = val.split('?')[1]
      // console.log(val,'===实际路由===',path);
      this.getHightLightByPathNOFlash(path,'')
      // this.getHightLightByPath(path);
    })
    window.vm.$on('childLangChange', (val) => {
      if (this.$route.path.includes('login')) {
      } else {
        // this.againSetSessionStorageChild()
      }
    })
    window.vm.$on('changeEnterprise', (val) => {
      console.log('点击店铺跳转 ==============>', val)
      this.changeShop(val)
    })
    // 切换语言后延期刷新角色列表：重载前只立标记，此处按新语言重新拉取（避免阻塞 reload）
    const pendingRoleRefresh = sessionStorage.getItem('pendingTradeRoleRefresh')
    sessionStorage.removeItem('pendingTradeRoleRefresh')
    if (pendingRoleRefresh || !this.tradeRoleList.length) {
      fetchTradeRoleList(this.$http).catch(e => console.log(e))
    }
    // 缓存列表已存在时，先按单角色场景校正一次
    this.ensureSingleTradeRole()
    window.vm.$on('tradeRoleListChange', (list) => {
      this.tradeRoleList = list || []
      // 角色列表更新后，若仅剩一个角色则默认选中该角色
      this.ensureSingleTradeRole()
    })
    window.vm.$on('tradeRoleChange', (role) => {
      this.tradeRole = role
    })
    window.vm.$on('addCart', (val) => {
      console.log('购物车数量 ==============>', val)
      this.cartNum = val
    })
    // 给店铺下拉菜单添加className
    const shopDropdownById = document
      .querySelector('.shopDropdown')
      .childNodes[0].getAttribute('aria-controls')
    document
      .getElementById(`${shopDropdownById}`)
      .classList.add('shopDropdownList')
    //监听页面刷新或者关闭
    // window.addEventListener('beforeunload', this.updateHandler)
  },
  destroyed() {
    clearInterval(this.timer)
    this.timer = null
  },
}
</script>
